import { useUnit } from 'effector-react'

import { css } from '@portal/styled-system/css'

import { useI18n } from '@/shared/lib/i18n'
import { Button, ButtonPlainBack } from '@/shared/ui'

import * as model from '../model'
import * as steps from '../steps'

export function StepSignupFailed() {
    const { i18n } = useI18n()
    const message = useUnit(model.$signupErrorMessage)

    const handleSignupButtonClick = () => {
        steps.showStepSignupEmail()
    }

    return (
        <div className={css({ display: 'flex', flexDirection: 'column', width: 'full', paddingBottom: '3' })}>
            <div className={css({ color: 'danger', textAlign: 'center', paddingBottom: '4' })}>{message}</div>

            <Button onPress={handleSignupButtonClick}>{i18n.BTN_BACK}</Button>
        </div>
    )
}

export function StepEmailMaybeUndeliverable() {
    const { i18n } = useI18n()

    const nonInteractive = useUnit(model.$interactionDisabled)

    const { email } = useUnit(model.$undeliverableEmail)

    const handleProceedButtonClick = () => {
        model.signupFormSubmitted({ skipValidation: true })
    }

    return (
        <div className={css({ display: 'flex', flexDirection: 'column' })}>
            <span
                dangerouslySetInnerHTML={{ __html: i18n.EMAIL_CONFIRM__BODY01 }}
                className={css({ textAlign: 'center', marginBottom: '3' })}
            />
            <span id="email-bind-confirm-email" className={css({ textAlign: 'center', marginBottom: '3' })}>
                <b>{email}</b>
            </span>
            <span className={css({ textAlign: 'center', marginBottom: '5' })}>{i18n.EMAIL_CONFIRM__BODY02}</span>
            <Button
                onPress={handleProceedButtonClick}
                isDisabled={nonInteractive}
                styles={css.raw({ marginBottom: '1' })}
            >
                {i18n.EMAIL_CONFIRM__BTN_PROCEED}
            </Button>
            <UseDifferentEmailButton />
        </div>
    )
}

export function StepAccountAlreadyExists() {
    const { i18n } = useI18n()

    const handleLoginButtonClick = () => {
        steps.showStepLogin()
    }

    return (
        <div className={css({ display: 'flex', flexDirection: 'column', gap: '1' })}>
            <div className={css({ color: 'danger', textAlign: 'center', paddingBottom: '[1.25rem]' })}>
                {i18n.TEXT_ACCOUNT_ALREADY_EXISTS}
            </div>

            <Button onPress={handleLoginButtonClick}>{i18n.BTN_GO_TO_LOGIN}</Button>
            <UseDifferentEmailButton />
        </div>
    )
}

export function StepPasswordTooSimple() {
    const { i18n } = useI18n()

    return (
        <div className={css({ display: 'flex', flexDirection: 'column' })}>
            <div className={css({ color: 'danger', textAlign: 'center', paddingBottom: '4' })}>
                {i18n.TEXT_PASSWORD_RECOMMENDATIONS}
            </div>

            <UseDifferentPasswordButton />
        </div>
    )
}

function UseDifferentEmailButton() {
    const { i18n } = useI18n()

    const handleUseDifferentEmailButtonClick = () => {
        steps.showStepSignupEmail()
    }

    return (
        <ButtonPlainBack onPress={handleUseDifferentEmailButtonClick}>
            <i className="fa-light fa-arrow-left-long" />
            &nbsp;&nbsp;{i18n.BTN_USE_DIF_EMAIL}
        </ButtonPlainBack>
    )
}

function UseDifferentPasswordButton() {
    const { i18n } = useI18n()

    const handleUseDifferentPasswordButtonClick = () => {
        steps.showStepSignupPassword()
    }

    return (
        <ButtonPlainBack onPress={handleUseDifferentPasswordButtonClick}>
            <i className="fa-light fa-arrow-left-long" />
            &nbsp;&nbsp;{i18n.BTN_USE_DIFF_PASS}
        </ButtonPlainBack>
    )
}
